import ContactSupport from '../../views/ContactSupport';

export default function ContactSupportPage() {
  return <ContactSupport />;
}
